import { render, staticRenderFns } from "./player.vue?vue&type=template&id=8fcf2cc0&"
import script from "./player.vue?vue&type=script&lang=js&"
export * from "./player.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports